// Category / collection index visible chrome (DEV-9884 cluster 5).
export const category = {
  en: {
    // h1 (sr-only) + h3 + breadcrumb label on the category index page.
    categories: "Categories",
    // Breadcrumb chrome shared by the PDP + category/product index pages:
    // the leading "Home" crumb and the "Products" fallback used when a
    // listing has no main collection to name the parent crumb.
    breadcrumbHome: "Home",
    breadcrumbProducts: "Products",
    // Alt fallback for a collection tile image when the CMS omits media.alt
    // and the collection has no name.
    collectionImageAlt: "Collection image",
    // CategoriesListing homepage block: per-tile CTA + block-level fallbacks
    // for when the BE returns no headline/ctaText override.
    exploreCategory: "Explore Category",
    shopByCategory: "Shop by Category",
    viewAllCategories: "View All Categories",
    // Product index page (/[market]/product) visible copy. {market} = uppercase
    // market code in the heading, lowercase in the subheading.
    allProductsHeading: "All Products - {market}",
    allProductsSubheading:
      "Browse all available products in the {market} market",
    noProductsFound: "No products found in this market.",
    productCount: {
      one: "Showing {count} product",
      other: "Showing {count} products",
    },
  },
  de: {
    categories: "Kategorien",
    breadcrumbHome: "Startseite",
    breadcrumbProducts: "Produkte",
    collectionImageAlt: "Kategoriebild",
    exploreCategory: "Kategorie entdecken",
    shopByCategory: "Nach Kategorie shoppen",
    viewAllCategories: "Alle Kategorien ansehen",
    allProductsHeading: "Alle Produkte - {market}",
    allProductsSubheading:
      "Alle verfügbaren Produkte im Markt {market} durchsuchen",
    noProductsFound: "In diesem Markt wurden keine Produkte gefunden.",
    productCount: {
      one: "{count} Produkt wird angezeigt",
      other: "{count} Produkte werden angezeigt",
    },
  },
} as const
